import { SolidPostInitRequest } from 'api/types/payment';

import { analyticSystemNumberMapper } from './constants';

import { ISubscription } from 'types/subscription';
import { SolidSuccessOrderResponse } from './types';

export const getValidateRecord = (cancelCandidate: ISubscription, order: SolidSuccessOrderResponse) => {
    const validateRecord: SolidPostInitRequest = {
        subscription_id: order?.subscription_id,
        payment_type: 'lifetime',
        payment_method: analyticSystemNumberMapper[cancelCandidate.payment_method],
        product_code: cancelCandidate.product_code,
        product_type: cancelCandidate.product_type,
        order_id: order?.order_id,
        order_type: 'fee_charge',
    };

    if (cancelCandidate.trial_period) {
        validateRecord.subscription_trial_period = cancelCandidate.trial_period;
    }

    if (cancelCandidate.period) {
        validateRecord.subscription_period = cancelCandidate.period;
    }

    return validateRecord;
};
